import { FunctionComponent, ReactNode } from "react";

interface FooterLinkProps {
  name: string;
  icon?: ReactNode;
}

const FooterLink: FunctionComponent<FooterLinkProps> = ({ name, icon }) => {
  return (
    <div className="mt-4 cursor-pointer tracking-tight justify-start">
      <div className="flex items-center">
        {icon && (
          <div
            className="mx-3 footer_svg_container inline-flex h-6 w-6 items-center justify-center shrink-0
    [&>svg]:h-full [&>svg]:w-full
    [&>svg]:block
    [&>svg]:overflow-visible"
          >
            {icon}
          </div>
        )}
        <p className="text-base leading-6 text-gray-500 hover:text-gray-900">
          {name}
        </p>
      </div>
    </div>
  );
};

export default FooterLink;
